import { ref } from 'vue';

export default () => {
  const globalSearch = ref('');
  return {
    state: { globalSearch },
    funcs: {}
  };
};
